<template>
  <div class="fillBlank">
    <span
      v-if="item.value.fillInBlanksAttribute.fill"
      style="position:relative; padding: 0 5px;"
      :class="{'star':item.value.fillInBlanksAttribute.fill}"
    ></span>
    {{(parseInt(pindex) + 1) + '.'}}
    <span v-for="(i, index) in fillArr" :key="index">
      <Input
        v-if="i === '' && index !== fillArr.length -1"
        v-model="item.value.fillInBlanksAttribute.answer[index]"
        :placeholder="fillBlankPlaceholder + minWordQuantity + maxWordQuantity + verifyIdCard + verifyPhone"
        class="fill_bgc"
        style="border: none;border-bottom: 1px solid #ccc;"
        id="input"
        @change="validateFill(item.value.fillInBlanksAttribute.answer[index], index)"
      />
      <span v-if="i">
        {{i}}
        <Input
          v-if="index !== fillArr.length -1"
          v-model="item.value.fillInBlanksAttribute.answer[index]"
          :placeholder="fillBlankPlaceholder + minWordQuantity + maxWordQuantity + verifyIdCard + verifyPhone"
          class="fill_bgc"
          style="border: none;border-bottom: 1px solid #ccc;"
          id="input"
          @change="validateFill(item.value.fillInBlanksAttribute.answer[index], index)"
        />
      </span>
    </span>
  </div>
</template>
<script>
export default {
  props: ['item', 'pindex'],
  data() {
    return {
      n: -1,
      fillBlankPlaceholder: '请输入',
      fillArr: [],
      minWordQuantity: '',
      maxWordQuantity: '',
      verifyIdCard: '',
      verifyPhone: '',
      fillFist: false,
      num: 0,
      windowHeight: document.body.scrollHeight,
    }
  },
  created: function () {
    // console.log(this.item.value.fillInBlanksAttribute.answer)

    this.minWordQuantity = this.item.value.fillInBlanksAttribute.minWordQuantity
      ? '(最少填' +
        this.item.value.fillInBlanksAttribute.minWordQuantity +
        '字)'
      : ''
    this.maxWordQuantity = this.item.value.fillInBlanksAttribute.maxWordQuantity
      ? '(最多填' +
        this.item.value.fillInBlanksAttribute.maxWordQuantity +
        '字),'
      : ''
    this.verifyIdCard = this.item.value.fillInBlanksAttribute.verifyIdCard
      ? '(请输入身份证号码)'
      : ''
    this.verifyPhone = this.item.value.fillInBlanksAttribute.verifyPhone
      ? '(请输入手机号码)'
      : ''
    this.fillBlankPlaceholder = this.item.value.fillInBlanksAttribute
      .defaultValue
      ? this.item.value.fillInBlanksAttribute.defaultValue
      : ''
    // console.log(this.item.value.fillInBlanksAttribute.name.indexOf("__________"))
    // 过滤空格
    this.fillArr = this.item.value.fillInBlanksAttribute.name.split(
      '__________'
    )
    // console.log(this.fillArr)
    // 特殊情况处理
    // if (this.fillArr[this.fillArr.length - 1] === "") {
    //   this.fillArr = this.fillArr.slice(0, this.fillArr.length - 1);
    // }

    // if()

    //  var fillNumber = this.item.value.fillInBlanksAttribute.name.split( "__________").length - 1
    // // 特殊情况
    // if(this.item.value.fillInBlanksAttribute.name.indexOf("__________") === 0) {
    //   this.fillFist = true
    // }

    // console.log(fillNumber)
    // console.log(fillItem)
    // this.fillArr = fillItem.filter(function(s) {
    //   return s && s.trim();
    // });
    // console.log(this.fillArr)
  },
  mounted: function () {},
  methods: {
    // 验证信息
    validateFill: function (val, index) {
      // console.log(val)
      // console.log(this.item.value.fillInBlanksAttribute.verifyPhone)
      // console.log(val.length)
      // console.log(this.item.value.fillInBlanksAttribute.minWordQuantity)
      // console.log(this.item.value.fillInBlanksAttribute.maxWordQuantity)
      // console.log(this.item.value.fillInBlanksAttribute.errorMessage)
      this.item.value.fillInBlanksAttribute.verifyStatus = true
      if (
        val.length <
          Number(this.item.value.fillInBlanksAttribute.minWordQuantity) &&
        this.item.value.fillInBlanksAttribute.minWordQuantity
      ) {
        this.$Message.warning(
          this.item.value.fillInBlanksAttribute.errorMessage != ''
            ? this.item.value.fillInBlanksAttribute.errorMessage
            : '最少填' +
                this.item.value.fillInBlanksAttribute.minWordQuantity +
                '字'
        )
        this.item.value.fillInBlanksAttribute.verifyStatus = false
        //  this.item.value.fillInBlanksAttribute.answer.splice(index, 1)
      } else if (
        val.length >
          Number(this.item.value.fillInBlanksAttribute.maxWordQuantity) &&
        this.item.value.fillInBlanksAttribute.maxWordQuantity
      ) {
        this.$Message.warning(
          this.item.value.fillInBlanksAttribute.errorMessage != ''
            ? this.item.value.fillInBlanksAttribute.errorMessage
            : '最多填' +
                this.item.value.fillInBlanksAttribute.maxWordQuantity +
                '字'
        )
        this.item.value.fillInBlanksAttribute.verifyStatus = false
        //  this.item.value.fillInBlanksAttribute.answer.splice(index, 1)
      } else if (this.item.value.fillInBlanksAttribute.verifyIdCard == true) {
        const idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
        if (idcardReg.test(val)) {
        } else {
          this.$Message.warning(
            this.item.value.fillInBlanksAttribute.errorMessage != ''
              ? this.item.value.fillInBlanksAttribute.errorMessage
              : '请输入正确的身份证号码'
          )
          this.item.value.fillInBlanksAttribute.verifyStatus = false
          // this.item.value.fillInBlanksAttribute.answer.splice(index, 1)
        }
      } else if (this.item.value.fillInBlanksAttribute.verifyPhone == true) {
        // const phoneReg = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
        var phoneReg = /^1[34578]\d{9}$/
        if (phoneReg.test(val)) {
        } else {
          this.$Message.warning(
            this.item.value.fillInBlanksAttribute.errorMessage != ''
              ? this.item.value.fillInBlanksAttribute.errorMessage
              : '请输入正确的手机号码'
          )
          this.item.value.fillInBlanksAttribute.verifyStatus = false
          //  this.item.value.fillInBlanksAttribute.answer.splice(index, 1)
        }
      }
      console.log(this.item.value.fillInBlanksAttribute.verifyStatus)
    },
  },
}
</script>
<style lang="less">
.fillBlank {
  .fill_bgc {
    width: 100px;
    height: 30px;
    border-bottom: 1px solid rgb(220, 220, 220);
    border-radius: 5px;
    box-sizing: border-box;
    outline: none;
    .ivu-input-inner-container .ivu-input.ivu-input-default {
      border: none !important;
      border-bottom: 1px solid #ccc !important;
      background-color: #fff;
    }
  }
  .star::after {
    position: absolute;
    top: -5px;
    left: 0;
    content: '*';
    color: #e64340;
    font-size: 20px;
  }
}
</style>


